import { render, staticRenderFns } from "./AssignmentList.vue?vue&type=template&id=cd7b3fe8&scoped=true&"
import script from "./AssignmentList.vue?vue&type=script&lang=js&"
export * from "./AssignmentList.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentList.vue?vue&type=style&index=0&id=cd7b3fe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7b3fe8",
  null
  
)

export default component.exports